import type { Project, ProjectId } from '@finsim/model';
import { createEvent, sample } from 'effector';
import { toastShown } from '../../entities/notifications';
import { $project, $readOnly } from '../../entities/project';
import { newId } from '../../shared/lib/id';
import { projectCreated } from '../create-project';

/**
 * "Save a copy" of a shared project: it becomes the viewer's own project (a new id), saved in
 * this browser (and synced, when signed in), and opens for editing.
 */
export const saveCopyRequested = createEvent();

const copied = sample({
  clock: saveCopyRequested,
  source: { project: $project, readOnly: $readOnly },
}).filterMap(({ project, readOnly }): Project | undefined =>
  project && readOnly ? { ...project, id: newId('prj') as ProjectId } : undefined,
);

sample({ clock: copied, target: projectCreated });
sample({
  clock: copied,
  fn: (project) => ({ message: 'viewer.copied' as const, params: { name: project.name } }),
  target: toastShown,
});
